import { useSyncExternalStore } from 'react';
let state = { available: false, apply: null };
const listeners = new Set();
// Staging walk item 8: has the person clicked, tapped or typed on this page
// load yet? Listening starts when this module loads, at app start.
let touched = false;
const TOUCH_EVENTS = ['pointerdown', 'keydown'];
function markTouched() {
    touched = true;
    if (typeof window === 'undefined')
        return;
    for (const type of TOUCH_EVENTS)
        window.removeEventListener(type, markTouched, true);
}
function watchForFirstTouch() {
    if (typeof window === 'undefined')
        return;
    for (const type of TOUCH_EVENTS)
        window.addEventListener(type, markTouched, true);
}
watchForFirstTouch();
/** True once the person has clicked, tapped or typed on this page load. */
export function pageHasBeenTouched() {
    return touched;
}
function emit() {
    for (const l of listeners)
        l();
}
/**
 * Called by the app's service-worker registration when a new worker is
 * waiting. With `applyIfUntouched`, an update found before the person has
 * done anything on the page is applied at once (one reload, nothing lost);
 * otherwise the prompt shows and only their click applies it.
 */
export function notifyServiceWorkerUpdate(apply, opts = {}) {
    if (opts.applyIfUntouched === true && !touched) {
        void apply();
        return;
    }
    state = { available: true, apply };
    emit();
}
/** Hide the prompt for this page load; the worker keeps waiting for the next one. */
export function dismissServiceWorkerUpdate() {
    if (!state.available)
        return;
    state = { available: false, apply: null };
    emit();
}
/** Test/reset hook. */
export function _resetServiceWorkerUpdateForTests() {
    state = { available: false, apply: null };
    touched = false;
    watchForFirstTouch();
    emit();
}
function subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
function getSnapshot() {
    return state;
}
export function useServiceWorkerUpdate() {
    const snapshot = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
    return {
        available: snapshot.available,
        apply: () => {
            void snapshot.apply?.();
        },
        dismiss: dismissServiceWorkerUpdate,
    };
}
//# sourceMappingURL=useServiceWorkerUpdate.js.map